
import React from 'react';
import { CardTitle, CardDescription, CardHeader } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { RefreshCw, UserPlus } from 'lucide-react';

interface CRMDashboardHeaderProps {
  onRefresh: () => void;
  onToggleAddForm: () => void;
  showAddForm: boolean;
}

const CRMDashboardHeader: React.FC<CRMDashboardHeaderProps> = ({
  onRefresh,
  onToggleAddForm,
  showAddForm,
}) => {
  return (
    <CardHeader className="pb-3">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        <div>
          <CardTitle>CRM Dashboard</CardTitle>
          <CardDescription>
            Manage user contacts and referral communications
          </CardDescription>
        </div>
        <div className="flex gap-2">
          <Button 
            variant="outline" 
            size="sm"
            onClick={onRefresh}
            className="flex items-center gap-1"
          >
            <RefreshCw className="h-4 w-4 mr-1" />
            Refresh
          </Button>
          <Button 
            size="sm"
            onClick={onToggleAddForm}
            className="flex items-center gap-1"
          >
            <UserPlus className="h-4 w-4 mr-1" />
            {showAddForm ? 'Cancel' : 'Add User'}
          </Button>
        </div>
      </div>
    </CardHeader>
  );
};

export default CRMDashboardHeader;

